import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { deleteBlog, getBlogById } from "../../api/BlogCategoryService";
import { getErrorMessage } from "../../utils/errorHandler";
import StatusBadge from "../Shared/StatusBadge";
import RecordActions from "../Shared/RecordActions";
import FullPageLoader from "../../common/FullPageLoader";

export default function BlogCategoryView() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCategory = async () => {
      try {
        if (!slug) {
          navigate("/blogcategory");
          return;
        }

        setLoading(true);

        const res = await getBlogById(slug);

        const categoryData = res?.data || res;

        setCategory(categoryData);
      } catch (error) {
        console.error("Failed to fetch blog category:", error);
        setCategory(null);
      } finally {
        setLoading(false);
      }
    };

    loadCategory();
  }, [slug, navigate]);

  if (loading) {
    return <FullPageLoader text="Loading blog category..." />;
  }

  if (!category) {
    return (
      <div className="container-fluid p-4">
        <div className="card p-3">
          <h5>Blog Category Not Found</h5>

          <button
            className="btn btn-secondary mt-3"
            style={{ width: "fit-content" }}
            onClick={() => navigate("/blogcategory")}
          >
            Back
          </button>
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (!category?._id || !window.confirm("Are you sure you want to delete this blog category?")) {
      return;
    }

    try {
      await deleteBlog(category._id);
      alert("Blog category deleted successfully");
      navigate("/blogcategory");
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="card p-3">
        <RecordActions
          onBack={() => navigate("/blogcategory")}
          onEdit={() =>
            navigate(`/blogcategory/edit/${category.seo?.slug || slug}`, {
              state: { blogId: category._id, slug: category.seo?.slug || slug },
            })
          }
          onDelete={handleDelete}
        />

        <div className="row">
          <div className="col-md-6 mb-3">
            <b>Name : </b>
            {category.name || "-"}
          </div>

          <div className="col-md-12 mb-3">
            <b>Description : </b>
            {category.description || "-"}
          </div>

          <div className="col-md-4 mb-3">
            <b>Status : </b>

            <StatusBadge status={category.status} className="ms-2" />
          </div>
        </div>
      </div>
    </div>
  );
}
